import React from 'react';
import * as Yup from 'yup';

import {
    FormControl,
    Input,
    FormLabel,
    HStack,
    Button,
    InputGroup,
    InputLeftElement,
    VStack,
    Box,
    FormErrorMessage
} from '@chakra-ui/react';
import { Formik, Form, useField } from 'formik';
import AddressInput from './AddressInput';
import { REALTOR_DEFAULT_VALUE } from 'constants/consumer';
import SelectInput from 'components/Input/SelectInput';
import statelist from 'constants/Select-constants/stateslist.json';
import { useUpdateRealtorMutation } from 'reducers/realtor.service';

const TextField = ({ label , ...props }) => {
    const [field, meta] = useField(props);
    return (
        <FormControl isInvalid={meta.touched && !!meta.error} mb={4}>
            <FormLabel>{label}</FormLabel>
            <InputGroup>
                {label === 'Website' && (
                    <InputLeftElement width={'4rem'} pointerEvents="none">
                        <p style={{ paddingLeft: '1.25rem', paddingRight: '1.25rem' }}>https://</p>
                    </InputLeftElement>
                )}
                <Input pl={label === 'Website' ? '4rem' : undefined} {...field} {...props} />
            </InputGroup>
            {/* <Input startElement={ label === 'website' ? <p>HTTPS</p> : null} {...field} {...props} /> */}
            <FormErrorMessage>{meta.error}</FormErrorMessage>
        </FormControl>
    );
};

export default function RealtorForm({ defaultValues = REALTOR_DEFAULT_VALUE, data, afterUpdateHandler = ()=>{}, handleCancel = ()=>{} }) {
    const [updateRealtor, { isLoading }] = useUpdateRealtorMutation();
    const handleUpdate = (values, actions)=>{
        delete values.bio;
        updateRealtor({ id: data?._id , body: values }).unwrap().then(()=>{
            afterUpdateHandler();
        });
    };
    return (
        <Formik
            initialValues={defaultValues}
            validationSchema={Yup.object({
                FirstName: Yup.string().required('Required'),
                LastName: Yup.string().required('Required'),
                Statelicenses: Yup.array().optional().label('State Licenses')
            })}
            onSubmit={handleUpdate}
        >
            {({ handleSubmit , setValues, setFieldValue }) => (
                <Form onSubmit={handleSubmit}>
                    <VStack align="stretch" spacing={4}>
                        <TextField name="FirstName" label="First Name" />
                        <TextField name="LastName" label="Last Name" />
                        <TextField name="collateral.biotext" label="Bio" />
                        <TextField name="website" label="Website" />
                        <SelectInput
                            issearch={true}
                            name={'Statelicenses'}
                            isMulti ={true} required={true} label={'State Licenses'} options={statelist} defaultValue={[]} />

                        <Box>
                            <AddressInput />
                        </Box>
                        <HStack justify="flex-end" gap={'0.5rem'}>
                            <Button variant="outline" type="reset" onClick={handleCancel }>
                                Cancel
                            </Button>
                            <Button disabled={isLoading} colorScheme="blue" type="submit">
                                {
                                    isLoading ? 'Saving...' : 'Save'
                                }
                            </Button>
                        </HStack>
                    </VStack>
                </Form>
            )}
        </Formik>
    );
}
